// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"Auctions_gridContainer__k2CxH","noAuctionsContainer":"Auctions_noAuctionsContainer__o3YOq"};